/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getShipmentSchedule } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export function useGetShipmentSchedule(id: string, options?: UseQueryOptions) {
  return useQuery({
    queryKey: shipmentQueryKeys.shipmentSchedule(id),
    queryFn: () => getShipmentSchedule(id).then((res) => res.data),
    ...options,
  });
}
